module.exports = __webpack_public_path__ + "img/30_11.c2737615.png";